// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para el Modal de Exportación */

.modal-overlay {
  position: fixed; /* Se queda fijo en la pantalla */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6); /* Fondo oscuro semi-transparente */
  display: flex; /* Usar flexbox para centrar */
  justify-content: center; /* Centrado horizontal */
  align-items: center; /* Centrado vertical */
  z-index: 1000; /* Asegura que esté por encima de otros elementos */
}

.modal-content {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  max-width: 90%; /* Evita que sea demasiado ancho en pantallas grandes */
  width: 400px; /* O un ancho fijo/máximo que prefieras */
}

.modal-content h4 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.3em;
}

.modal-content p {
  margin-bottom: 0;
  font-size: 1em;
  color: #333;
}

/* Estilos para el Spinner CSS Básico */
.modal-spinner {
  border: 5px solid #f3f3f3; /* Gris claro */
  border-top: 5px solid #3498db; /* Azul */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 25px auto; /* Centrado y con margen inferior */
}

/* Animación para el spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Puedes añadir otros estilos generales de App.css aquí si lo necesitas */
/* .App { ... } */
/* table { ... } */
/* button { ... } */

/* Estilos Generales e Inspirados */

/* Reset básico y fuente global */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; /* Fuente sans-serif limpia por defecto */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fa; /* Un fondo gris muy claro */
  color: #333; /* Color de texto principal oscuro */
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Contenedor principal de la App */
.App {
  max-width: 1200px; /* Limita el ancho máximo */
  margin: 20px auto; /* Centra el contenedor */
  padding: 20px;
  background-color: #fff; /* Fondo blanco para el contenido principal */
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* Sombra sutil */
}

/* Contenedor específico para Bienvenida + Logout */
.user-actions {
  display: flex;
  align-items: center;
  gap: 15px; /* <-- ESPACIO ENTRE BIENVENIDA Y BOTÓN LOGOUT */
}

/* Opcional: Evitar que el nombre de usuario se rompa o empuje demasiado */
.user-actions span {
  white-space: nowrap; /* Evita que el nombre se parta en varias líneas */
  overflow: hidden;
  text-overflow: ellipsis; /* Añade "..." si es muy largo */
  max-width: 200px; /* Ajusta este ancho máximo según necesites */
  flex-shrink: 1; /* Permite que se encoja si es necesario */
}
.user-actions button {
  flex-shrink: 0; /* Evita que el botón se encoja */
}

/* Cabecera */
.App-header {
  border-bottom: 2px solid #dee2e6; /* Borde inferior más pronunciado */
  padding-bottom: 15px;
  margin-bottom: 25px;
  display: flex; /* Para alinear título y login/logout */
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* Permitir que se envuelva en pantallas pequeñas */
  gap: 20px; /* <-- AÑADE ESTO: Espacio entre título, idioma, user/logout */

}

.App-header h1 {
  color: #003366; /* Un azul oscuro para el título */
  margin: 0;
  font-size: 1.8em;
}

.App-header span {
    font-weight: 500;
}

/* Botones Generales */
button {
  cursor: pointer;
  padding: 8px 15px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 0.95em;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  background-color: #0056b3; /* Azul primario */
  color: white;
}

button:hover:not(:disabled) {
  background-color: #004494; /* Azul más oscuro al pasar el ratón */
}

button:disabled {
  background-color: #cccccc; /* Gris para botones deshabilitados */
  cursor: not-allowed;
  opacity: 0.7;
}

/* Botones específicos si necesitas */
.App-header button {
  background-color: #6c757d; /* Gris para logout/login */
}
.App-header button:hover:not(:disabled) {
  background-color: #5a6268;
}

/* Formulario de Búsqueda */
form input[type="text"] {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1em;
  min-width: 300px; /* O usa % */
}
form button[type="submit"] {
  background-color: #28a745; /* Verde para búsqueda */
  margin-left: 5px;
}
form button[type="submit"]:hover:not(:disabled) {
  background-color: #218838;
}

/* Controles (Paginación, Exportar, Tamaño Página) */
.controls-bar { /* Puedes añadir esta clase al div que contiene los controles */
    margin-bottom: 15px;
    padding: 15px;
    background: #e9ecef; /* Fondo gris claro para la barra de controles */
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; /* Para que se adapte a pantallas pequeñas */
    gap: 15px; /* Espacio entre grupos de controles */
}

/* Contenedor para todos los controles de la derecha */
.header-right-controls {
  display: flex;
  align-items: center;
  gap: 20px; /* Espacio entre selector de idioma y user/login actions */
  flex-wrap: wrap; /* Permitir que se envuelva si no cabe */
} 

.view-switcher {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.view-switcher button {
  background-color: #6c757d;
}

.view-switcher button.active {
  background-color: #0056b3;
}

.controls-bar label {
    margin-right: 5px;
    font-weight: 500;
}
.controls-bar select {
    padding: 5px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}
.controls-bar button { /* Botones dentro de la barra */
    background-color: #007bff; /* Azul un poco más brillante */
}
.controls-bar button:hover:not(:disabled) {
    background-color: #0056b3;
}
.controls-bar button.export-button { /* Clase específica si quieres */
    background-color: #17a2b8; /* Cyan para exportar */
}
.controls-bar button.export-button:hover:not(:disabled) {
    background-color: #138496;
}

/* Tabla de Resultados */
.table-container { /* Añade esta clase al div que envuelve la tabla */
  overflow-x: auto; /* Scroll horizontal en pantallas pequeñas */
  margin-top: 15px;
}

table {
  width: 100%;
  border-collapse: collapse; /* Bordes colapsados */
  border: 1px solid #dee2e6; /* Borde exterior ligero */
}

th, td {
  padding: 10px 12px; /* Más padding */
  text-align: left;
  border-bottom: 1px solid #dee2e6; /* Líneas horizontales */
  word-break: break-all; /* Evita que palabras largas rompan el layout */
}

th {
  background-color: #e9ecef; /* Fondo gris claro para cabeceras */
  font-weight: 600; /* Texto en negrita */
  white-space: nowrap; /* Evita que las cabeceras se partan */
}

tbody tr:nth-child(even) {
  background-color: #f8f9fa; /* Filas alternas ligeramente coloreadas */
}

tbody tr:hover {
  background-color: #ddeeff; /* Resaltado azul claro al pasar el ratón */
}

td:last-child, th:last-child {
    /* border-right: none; */ /* Opcional: quitar borde derecho en la última columna */
}

/* Checkbox Mostrar Contraseñas (Si todavía lo tienes) */
.password-toggle label {
    cursor: pointer;
    display: flex; /* Alinear checkbox y texto */
    align-items: center;
    justify-content: flex-end; /* Alinear a la derecha */
}
.password-toggle input[type="checkbox"] {
    margin-right: 8px;
}
.password-toggle .warning-text { /* Añade esta clase al span de advertencia */
    color: #dc3545; /* Rojo para advertencia */
    font-weight: bold;
    margin-left: 5px;
}


/* Mensajes (Error, Info) */
.error-message { /* Añade esta clase al <p> de error */
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 10px 15px;
  border-radius: 4px;
  margin-top: 15px;
}
.loading-message, .info-message { /* Añade info-message a los <p> informativos */
  color: #0c5460;
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  padding: 10px 15px;
  border-radius: 4px;
  margin-top: 15px;
  font-style: italic;
}


/* Estilos para el Modal de Exportación */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  max-width: 90%;
  width: 400px;
}
.modal-content h4 {
  margin-top: 0; margin-bottom: 15px; font-size: 1.3em; color: #003366;
}
.modal-content p {
  margin-bottom: 0; font-size: 1em; color: #333;
}
.modal-spinner {
  border: 5px solid #f3f3f3; border-top: 5px solid #0056b3; /* Azul primario */
  border-radius: 50%; width: 40px; height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 25px auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Selectores de Idioma */
.language-switcher button { /* Aplica a los botones EN/ES */
    padding: 4px 8px;
    font-size: 0.8em;
    margin-left: 5px;
    background-color: #f8f9fa;
    color: #0056b3;
    border: 1px solid #dee2e6;
}
.language-switcher button:hover:not(:disabled) {
    background-color: #e2e6ea;
}
.language-switcher button:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: default;
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,eAAe,EAAE,iCAAiC;EAClD,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,mCAAmC;EACzE,aAAa,EAAE,8BAA8B;EAC7C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,aAAa,EAAE,mDAAmD;AACpE;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc,EAAE,uDAAuD;EACvE,YAAY,EAAE,yCAAyC;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,wBAAwB,EAAE,mCAAmC;AAC/D;;AAEA,8BAA8B;AAC9B;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,0EAA0E;AAC1E,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;;AAEnB,mCAAmC;;AAEnC,iCAAiC;AACjC;EACE,SAAS;EACT;;cAEY,EAAE,yCAAyC;EACvD,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB,EAAE,4BAA4B;EACvD,WAAW,EAAE,oCAAoC;EACjD,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,mCAAmC;AACnC;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,iBAAiB,EAAE,yBAAyB;EAC5C,aAAa;EACb,sBAAsB,EAAE,6CAA6C;EACrE,kBAAkB;EAClB,qCAAqC,EAAE,iBAAiB;AAC1D;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,gDAAgD;AAC7D;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB,EAAE,kDAAkD;EACvE,gBAAgB;EAChB,uBAAuB,EAAE,gCAAgC;EACzD,gBAAgB,EAAE,6CAA6C;EAC/D,cAAc,EAAE,0CAA0C;AAC5D;AACA;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA,aAAa;AACb;EACE,gCAAgC,EAAE,mCAAmC;EACrE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa,EAAE,uCAAuC;EACtD,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAE,mDAAmD;EACpE,SAAS,EAAE,8DAA8D;;AAE3E;;AAEA;EACE,cAAc,EAAE,kCAAkC;EAClD,SAAS;EACT,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,yDAAyD;EACzD,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,yBAAyB,EAAE,2BAA2B;AACxD;AACA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB,EAAE,YAAY;AAChC;AACA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD,gBAAgB,+DAA+D;IAC3E,mBAAmB;IACnB,aAAa;IACb,mBAAmB,EAAE,gDAAgD;IACrE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe,EAAE,4CAA4C;IAC7D,SAAS,EAAE,sCAAsC;AACrD;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,0DAA0D;EACrE,eAAe,EAAE,wCAAwC;AAC3D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;AACA,uBAAuB,+BAA+B;IAClD,yBAAyB,EAAE,+BAA+B;AAC9D;AACA;IACI,yBAAyB;AAC7B;AACA,qCAAqC,gCAAgC;IACjE,yBAAyB,EAAE,uBAAuB;AACtD;AACA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB,mBAAmB,kDAAkD;EACnE,gBAAgB,EAAE,4CAA4C;EAC9D,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,sBAAsB;EACjD,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,gBAAgB;EAChB,gCAAgC,EAAE,wBAAwB;EAC1D,qBAAqB,EAAE,+CAA+C;AACxE;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,gBAAgB,EAAE,qBAAqB;EACvC,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA;EACE,yBAAyB,EAAE,0CAA0C;AACvE;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;AACxE;;AAEA;IACI,wBAAwB,EAAE,wDAAwD;AACtF;;AAEA,wDAAwD;AACxD;IACI,eAAe;IACf,aAAa,EAAE,6BAA6B;IAC5C,mBAAmB;IACnB,yBAAyB,EAAE,yBAAyB;AACxD;AACA;IACI,iBAAiB;AACrB;AACA,iCAAiC,4CAA4C;IACzE,cAAc,EAAE,0BAA0B;IAC1C,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA,2BAA2B;AAC3B,iBAAiB,qCAAqC;EACpD,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kCAAkC,8CAA8C;EAC9E,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,yCAAyC;AACzC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc;AACtE;AACA;EACE,gBAAgB,EAAE,cAAc,EAAE,WAAW;AAC/C;AACA;EACE,yBAAyB,EAAE,6BAA6B,EAAE,kBAAkB;EAC5E,kBAAkB,EAAE,WAAW,EAAE,YAAY;EAC7C,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,yBAAyB;AACzB,4BAA4B,+BAA+B;IACvD,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,UAAU;AACd","sourcesContent":["/* Estilos para el Modal de Exportación */\n\n.modal-overlay {\n  position: fixed; /* Se queda fijo en la pantalla */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6); /* Fondo oscuro semi-transparente */\n  display: flex; /* Usar flexbox para centrar */\n  justify-content: center; /* Centrado horizontal */\n  align-items: center; /* Centrado vertical */\n  z-index: 1000; /* Asegura que esté por encima de otros elementos */\n}\n\n.modal-content {\n  background-color: #fff;\n  padding: 30px 40px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  max-width: 90%; /* Evita que sea demasiado ancho en pantallas grandes */\n  width: 400px; /* O un ancho fijo/máximo que prefieras */\n}\n\n.modal-content h4 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 1.3em;\n}\n\n.modal-content p {\n  margin-bottom: 0;\n  font-size: 1em;\n  color: #333;\n}\n\n/* Estilos para el Spinner CSS Básico */\n.modal-spinner {\n  border: 5px solid #f3f3f3; /* Gris claro */\n  border-top: 5px solid #3498db; /* Azul */\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 25px auto; /* Centrado y con margen inferior */\n}\n\n/* Animación para el spinner */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Puedes añadir otros estilos generales de App.css aquí si lo necesitas */\n/* .App { ... } */\n/* table { ... } */\n/* button { ... } */\n\n/* Estilos Generales e Inspirados */\n\n/* Reset básico y fuente global */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif; /* Fuente sans-serif limpia por defecto */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8f9fa; /* Un fondo gris muy claro */\n  color: #333; /* Color de texto principal oscuro */\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Contenedor principal de la App */\n.App {\n  max-width: 1200px; /* Limita el ancho máximo */\n  margin: 20px auto; /* Centra el contenedor */\n  padding: 20px;\n  background-color: #fff; /* Fondo blanco para el contenido principal */\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* Sombra sutil */\n}\n\n/* Contenedor específico para Bienvenida + Logout */\n.user-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px; /* <-- ESPACIO ENTRE BIENVENIDA Y BOTÓN LOGOUT */\n}\n\n/* Opcional: Evitar que el nombre de usuario se rompa o empuje demasiado */\n.user-actions span {\n  white-space: nowrap; /* Evita que el nombre se parta en varias líneas */\n  overflow: hidden;\n  text-overflow: ellipsis; /* Añade \"...\" si es muy largo */\n  max-width: 200px; /* Ajusta este ancho máximo según necesites */\n  flex-shrink: 1; /* Permite que se encoja si es necesario */\n}\n.user-actions button {\n  flex-shrink: 0; /* Evita que el botón se encoja */\n}\n\n/* Cabecera */\n.App-header {\n  border-bottom: 2px solid #dee2e6; /* Borde inferior más pronunciado */\n  padding-bottom: 15px;\n  margin-bottom: 25px;\n  display: flex; /* Para alinear título y login/logout */\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap; /* Permitir que se envuelva en pantallas pequeñas */\n  gap: 20px; /* <-- AÑADE ESTO: Espacio entre título, idioma, user/logout */\n\n}\n\n.App-header h1 {\n  color: #003366; /* Un azul oscuro para el título */\n  margin: 0;\n  font-size: 1.8em;\n}\n\n.App-header span {\n    font-weight: 500;\n}\n\n/* Botones Generales */\nbutton {\n  cursor: pointer;\n  padding: 8px 15px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  font-size: 0.95em;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n  background-color: #0056b3; /* Azul primario */\n  color: white;\n}\n\nbutton:hover:not(:disabled) {\n  background-color: #004494; /* Azul más oscuro al pasar el ratón */\n}\n\nbutton:disabled {\n  background-color: #cccccc; /* Gris para botones deshabilitados */\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Botones específicos si necesitas */\n.App-header button {\n  background-color: #6c757d; /* Gris para logout/login */\n}\n.App-header button:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n/* Formulario de Búsqueda */\nform input[type=\"text\"] {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1em;\n  min-width: 300px; /* O usa % */\n}\nform button[type=\"submit\"] {\n  background-color: #28a745; /* Verde para búsqueda */\n  margin-left: 5px;\n}\nform button[type=\"submit\"]:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n/* Controles (Paginación, Exportar, Tamaño Página) */\n.controls-bar { /* Puedes añadir esta clase al div que contiene los controles */\n    margin-bottom: 15px;\n    padding: 15px;\n    background: #e9ecef; /* Fondo gris claro para la barra de controles */\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap; /* Para que se adapte a pantallas pequeñas */\n    gap: 15px; /* Espacio entre grupos de controles */\n}\n\n/* Contenedor para todos los controles de la derecha */\n.header-right-controls {\n  display: flex;\n  align-items: center;\n  gap: 20px; /* Espacio entre selector de idioma y user/login actions */\n  flex-wrap: wrap; /* Permitir que se envuelva si no cabe */\n} \n\n.view-switcher {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.view-switcher button {\n  background-color: #6c757d;\n}\n\n.view-switcher button.active {\n  background-color: #0056b3;\n}\n\n.controls-bar label {\n    margin-right: 5px;\n    font-weight: 500;\n}\n.controls-bar select {\n    padding: 5px 8px;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n}\n.controls-bar button { /* Botones dentro de la barra */\n    background-color: #007bff; /* Azul un poco más brillante */\n}\n.controls-bar button:hover:not(:disabled) {\n    background-color: #0056b3;\n}\n.controls-bar button.export-button { /* Clase específica si quieres */\n    background-color: #17a2b8; /* Cyan para exportar */\n}\n.controls-bar button.export-button:hover:not(:disabled) {\n    background-color: #138496;\n}\n\n/* Tabla de Resultados */\n.table-container { /* Añade esta clase al div que envuelve la tabla */\n  overflow-x: auto; /* Scroll horizontal en pantallas pequeñas */\n  margin-top: 15px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse; /* Bordes colapsados */\n  border: 1px solid #dee2e6; /* Borde exterior ligero */\n}\n\nth, td {\n  padding: 10px 12px; /* Más padding */\n  text-align: left;\n  border-bottom: 1px solid #dee2e6; /* Líneas horizontales */\n  word-break: break-all; /* Evita que palabras largas rompan el layout */\n}\n\nth {\n  background-color: #e9ecef; /* Fondo gris claro para cabeceras */\n  font-weight: 600; /* Texto en negrita */\n  white-space: nowrap; /* Evita que las cabeceras se partan */\n}\n\ntbody tr:nth-child(even) {\n  background-color: #f8f9fa; /* Filas alternas ligeramente coloreadas */\n}\n\ntbody tr:hover {\n  background-color: #ddeeff; /* Resaltado azul claro al pasar el ratón */\n}\n\ntd:last-child, th:last-child {\n    /* border-right: none; */ /* Opcional: quitar borde derecho en la última columna */\n}\n\n/* Checkbox Mostrar Contraseñas (Si todavía lo tienes) */\n.password-toggle label {\n    cursor: pointer;\n    display: flex; /* Alinear checkbox y texto */\n    align-items: center;\n    justify-content: flex-end; /* Alinear a la derecha */\n}\n.password-toggle input[type=\"checkbox\"] {\n    margin-right: 8px;\n}\n.password-toggle .warning-text { /* Añade esta clase al span de advertencia */\n    color: #dc3545; /* Rojo para advertencia */\n    font-weight: bold;\n    margin-left: 5px;\n}\n\n\n/* Mensajes (Error, Info) */\n.error-message { /* Añade esta clase al <p> de error */\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n}\n.loading-message, .info-message { /* Añade info-message a los <p> informativos */\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n  font-style: italic;\n}\n\n\n/* Estilos para el Modal de Exportación */\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.modal-content {\n  background-color: #fff;\n  padding: 30px 40px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  max-width: 90%;\n  width: 400px;\n}\n.modal-content h4 {\n  margin-top: 0; margin-bottom: 15px; font-size: 1.3em; color: #003366;\n}\n.modal-content p {\n  margin-bottom: 0; font-size: 1em; color: #333;\n}\n.modal-spinner {\n  border: 5px solid #f3f3f3; border-top: 5px solid #0056b3; /* Azul primario */\n  border-radius: 50%; width: 40px; height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 25px auto;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Selectores de Idioma */\n.language-switcher button { /* Aplica a los botones EN/ES */\n    padding: 4px 8px;\n    font-size: 0.8em;\n    margin-left: 5px;\n    background-color: #f8f9fa;\n    color: #0056b3;\n    border: 1px solid #dee2e6;\n}\n.language-switcher button:hover:not(:disabled) {\n    background-color: #e2e6ea;\n}\n.language-switcher button:disabled {\n    background-color: #e9ecef;\n    color: #6c757d;\n    cursor: default;\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
